<template>
  <div class="modal fade" id="createKeywordModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">
            New Keyword
          </h5>
          <h5 v-if="editing" class="modal-title">
            Edit Keyword
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveKeyword">
            <div class="form-group">
              <label for="category">Keyword</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Keyword"
                required
                v-model="name"
              />
            </div>
            <div class="form-group">
              <label for="summary">Definition</label>
              <textarea
                type="text"
                class="form-control"
                id="definition"
                placeholder="Definition"
                rows="6"
                required
                v-model="definition"
              />
            </div>

            <div class="form-group">
              <label>Applicable Groups</label>
              <select
                name="applicabilityPicker"
                class="selectpicker d-block"
                data-style="btn-outline-primary"
                multiple
                data-none-selected-text="No Specific Groups"
                data-actions-box="true"
                data-selected-text-format="count"
                v-model="applicability"
              >
                <option
                  v-for="applicability in availableApplicabilities"
                  :key="applicability.value"
                  v-bind:value="applicability.value"
                >
                  {{ applicability.description }}
                </option>
              </select>
              <p class="text-secondary">
                {{ getApplicabilityList() }}
              </p>
              <p v-if="applicability.length == 0" class="text-secondary">
                This will not appear on any of the specific pages.
              </p>
            </div>

            <div class="text-right">
              <button
                v-if="editing"
                type="button"
                v-on:click="deleteKeyword"
                class="float-left btn btn-danger"
              >
                Delete Keyword
              </button>
              <button v-if="editing" class="btn btn-primary">
                Update Keyword
              </button>
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create Keyword
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { keywordApplicabilities } from "@/constants/KeywordApplicabilities";

export default {
  name: "CreateKeywordModal",
  props: {
    KeywordToEdit: Object
  },
  data() {
    return {
      name: "",
      definition: "",
      applicability: [0],
      editingKeyword: null,
      editing: false,
      availableApplicabilities: keywordApplicabilities
    };
  },
  watch: {
    KeywordToEdit: function() {
      if (this.KeywordToEdit != null) {
        this.name = this.KeywordToEdit.Name;
        this.definition = this.KeywordToEdit.Definition;
        this.applicability = this.$createKeywordApplicabilityValueList(
          this.KeywordToEdit.Applicability
        );
        this.editingKeyword = this.KeywordToEdit;
        $("select[name=applicabilityPicker]").val(this.applicability);
        $(".selectpicker").selectpicker("refresh");
        this.editing = true;
      } else {
        this.clearFields();
        this.editing = false;
      }
    }
  },
  mounted() {
    $("#createKeywordModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
    $(".selectpicker").selectpicker("refresh");
  },
  methods: {
    getApplicabilityList() {
      var filteredApplicabilities = this.availableApplicabilities.filter(a =>
        this.applicability.includes(a.value)
      );
      if (
        filteredApplicabilities.length == this.availableApplicabilities.length
      ) {
        return "All Apply";
      } else {
        return filteredApplicabilities.map(a => a.description).join(", ");
      }
    },
    async saveKeyword() {
      if (this.editing) {
        await this.updateKeyword();
      } else {
        await this.createKeyword();
      }
    },
    async createKeyword() {
      var view = this;
      $("#createKeywordModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var keywordToCreate = {
        Name: view.$data.name,
        Definition: view.$data.definition,
        Applicability: view.$createGrantFlag(view.$data.applicability)
      };
      await this.$createKeyword(keywordToCreate)
        .then(newKeyword => {
          view.$emit("addedKeyword", newKeyword);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createKeywordModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async updateKeyword() {
      var view = this;
      $("#createKeywordModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var keywordToCreate = {
        Keyword_Id: view.$data.editingKeyword.Keyword_Id,
        Name: view.$data.name,
        Definition: view.$data.definition,
        Applicability: view.$createGrantFlag(view.$data.applicability)
      };
      await this.$updateKeyword(keywordToCreate)
        .then(editedKeyword => {
          view.$emit("editedKeyword", editedKeyword);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createKeywordModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async deleteKeyword() {
      var view = this;
      $("#createKeywordModal").modal("hide");
      await this.$deleteKeyword(view.editingKeyword)
        .then(() => {
          view.$emit("deletedKeyword", view.editingKeyword.Keyword_Id);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createKeywordModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      (this.name = ""), (this.definition = ""), (this.applicability = []);
    }
  }
};
</script>
